import { Box } from '@mui/material';
import { CONTENT_HEADER_FIELD_DEFS } from './contentHeaderFieldDefs';
import ContentHeaderField from './ContentHeaderField';
import JInspector from '../../components/shared/JInspectorComponents/JInspector';
import prioUpdater from './PrioUpdater';

import '../../theme/jTheme.css';
import { useInspector } from '../../contexts/InspectorContext';

const _name = 'ContentPanelMeta';

// Renders a single row of field chips — skips fields with no value ('—')
const FieldRow = ({ defs, entry, id }) => {
    const visibleDefs = defs.filter((def) => {
        const raw = entry?.[def.key];
        const display = def.getDisplayValue ? def.getDisplayValue(raw) : def.type === 'date' ? raw : raw || '—';
        return display !== '—';
    });

    return (
        <Box
            id={id}
            sx={{
                pt: '4px',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                overflow: 'hidden',
                rowGap: 0,
                columnGap: 0,
            }}
        >
            {visibleDefs.map((def) => (
                <ContentHeaderField key={def.key} field={def.key} def={def} value={entry?.[def.key]} />
            ))}
        </Box>
    );
};

// compact=true — all fields in one row (used in EntryPanel list items)
// compact=false (default) — two rows split by row property
export default function ContentPanelMeta({ entry, compact = false }) {
    const sortedDefs = [...CONTENT_HEADER_FIELD_DEFS].sort((a, b) => a.order - b.order);
    const { activeGid } = useInspector();

    if (compact) {
        return <FieldRow id="cpm-field-row-compact" defs={sortedDefs} entry={entry} />;
    }

    const row1 = sortedDefs.filter((d) => d.row === 1);
    const row2 = sortedDefs.filter((d) => d.row === 2);

    const handleSave = async (changes) => {
        await prioUpdater.save({ ...entry, ...changes }, activeGid);
    };

    return (
        <Box id="cpm-root" sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            <JInspector entry={entry} onSave={handleSave}>
                <FieldRow id="cpm-field-row-1" defs={row1} entry={entry} />
            </JInspector>
            <FieldRow id="cpm-field-row-2" defs={row2} entry={entry} />
        </Box>
    );
}
